module.exports = __webpack_public_path__ + "media/images/flags/1x1/com-23bac3d0082f65aa494d039e5648b0f0.svg";